import axios from 'axios';
import { Toast } from 'react-bootstrap';
import {Buffer} from 'buffer';
import Data from '../../../utils/SetGetData';
const API_URL = process.env.REACT_APP_API_URL;
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}refreshUserInformation`;
export const LOGIN_URL = `${API_URL}/appLogin`;
export const REGISTER_URL = `${API_URL}/register`;
export const REQUEST_PASSWORD_URL = `${API_URL}forgetAppPassword`;
export const REQUEST_PASSWORD_URL_RESELLER = `${API_URL}forgetResellerPassword`;

// Server should return AuthModel
export function login(email, password) {
}
// Server should return AuthModel
export function register(email, firstname, lastname, password, password_confirmation) {
    return axios.post(REGISTER_URL, {
        email,
        first_name: firstname,
        last_name: lastname,
        password,
        password_confirmation,
    });
}
// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email) {
    return axios.post(REQUEST_PASSWORD_URL, {
        username:email,
    });
}
export function requestPasswordReseller(email) {
    return axios.post(REQUEST_PASSWORD_URL_RESELLER, {
        email:email,
    });
}
export function getUserByToken(token) {
    
    const S_Token=localStorage.getItem('S_Token')
    return axios.post(GET_USER_BY_ACCESSTOKEN_URL, {
        token
    }, {
        headers: {
            Token: S_Token 
        }
      });
}
// export function getUserByToken(token) {
//     return Data.getData('userInfo')
// }
